import React, { useState } from 'react';

import banner1 from '../components/img/banner1.jpg';
import banner2 from '../components/img/banner2.jpg';
import banner3 from '../components/img/banner3.jpg';

const Carousal = () => {
  const images = [banner1, banner2, banner3];
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="carousel">
      <div className="carousel-images">
        <img
          src={images[currentIndex]}
          alt={`banner ${currentIndex + 1}`}
          className="carousel-image"
        />
      </div>
      <div className="carousel-controls">
        <button onClick={prevImage} className="carousel-control-btn">
          &#10094; Prev
        </button>
        <button onClick={nextImage} className="carousel-control-btn">
          Next &#10095;
        </button>
      </div>
    </div>
  );
};

export default Carousal;
